'use strict';

angular.module('cimerFrontEndApp').directive('upload', [function () {
    return {
        restrict: 'E',
        templateUrl: '/Content/Templates/uploadTemplate.html',
        scope: {
            accepts: '=accepts',
            uploadFunction: '=uploadFunction',
            maxSize: '=?maxSize',
            clearData: '=?clearData'
        },
        link: function (scope, element, attrs) {
            scope.acceptsList = scope.accepts.join(',');
            if (!scope.maxSize) {
                scope.maxSize = '4MB';
            }

            scope.UploadError = false;
            scope.UploadedFile = null;
            scope.Uploading = false;
            scope.Upload = function ($file) {
                if ($file === null) {
                    scope.Uploading = false;
                    scope.UploadError = false;
                    scope.UploadedFile = null;
                    return;
                }

                scope.UploadedFile = $file;
                try {
                    scope.Uploading = true;
                    scope.UploadError = false;
                    if (scope.uploadFunction) {
                        scope.uploadFunction($file);
                    }
                    scope.Uploading = false;
                }
                catch (e) {
                    scope.Uploading = false;
                    scope.UploadError = true;
                }
                scope.$watch('clearData', function (newValue, oldValue) {
                    if (newValue && !oldValue) {
                        scope.UploadedFile = null;
                        scope.clearData = false;
                    }
                });

            };
        }
    };
}]);
